import styled from 'styled-components';
import {
  BLUE,
} from 'root/theme';


const Container = styled.div`
  display: block;
  justify-content: center;
  text-align: left;
  margin: 0 40px;
  padding: 40px 0px 20px 0px;
  font-size: 18px;
  max-height: 90%;
  overflow: auto;
`;

const EmailText = styled.div`
  color: ${BLUE};
  margin: 40px 0;
  font-weight: bold;
`;


export {
  Container,
  EmailText,
};
